import React, { FC } from 'react'

import { RewardsQuery } from '../../../../../../graphql/search'
import { RewardsCard } from '../../RewardsCard'
import { MonthlyRewardsProgress } from './MonthlyRewardsProgress'
import { SalesOverviewGeneral } from './SalesOverviewGeneral'

export interface SalesOverviewCardProps {
  currentSnapshot?: NonNullable<
    NonNullable<RewardsQuery['customer']>['rewardsSnapshots']
  >['nodes'][number]
}

export const SalesOverviewCard: FC<SalesOverviewCardProps> = ({ currentSnapshot }) => {
  return (
    <RewardsCard>
      <SalesOverviewGeneral currentSnapshot={currentSnapshot} />
      <MonthlyRewardsProgress currentSnapshot={currentSnapshot} />
    </RewardsCard>
  )
}
